const getPaywallSeoClass = ({ className = "paywall", index = 3 }, nodeIndex) => nodeIndex < index && className;
const isPaywallSeo = (seoMode) => typeof seoMode === "object" && typeof (seoMode == null ? void 0 : seoMode.paywall) === "object";

export { getPaywallSeoClass, isPaywallSeo };
//# sourceMappingURL=paywallSeo.js.map
